import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, ArrowRight } from "lucide-react";

import "./SponsorThanks.css";

export default function SponsorThanks() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState({
    payment_status: "polling",
    attempts: 0,
  });

  useEffect(() => {
    if (!sessionId) return;
    let cancel = false;
    let attempts = 0;

    const poll = async () => {
      if (cancel || attempts >= 10) return;
      attempts += 1;

      await new Promise((resolve) => setTimeout(resolve, 1800));
      if (cancel) return;

      const simulatedStatus = attempts >= 3 ? "paid" : "polling";
      setStatus({ payment_status: simulatedStatus, attempts });

      if (simulatedStatus === "paid") return;
      poll();
    };

    poll();
    return () => {
      cancel = true;
    };
  }, [sessionId]);

  const paid = status.payment_status === "paid";

  return (
    <div
      data-testid="sponsor-thanks"
      className="sponsorThanksPage"
      style={{
        background: "linear-gradient(180deg, #061412 0%, #0A1D1A 100%)",
      }}
    >
      <div className="container-x sponsorThanksInner">
        {paid ? (
          <>
            <CheckCircle2 size={56} className="sponsorThanksSuccessIcon" />
            <p className="overline sponsorThanksOverline">Sponsorship confirmed</p>
            <h1 className="font-display sponsorThanksTitle">
              Welcome to vmeetio.
            </h1>
            <p className="sponsorThanksBody">
              Your payment is in. Our team will review your branding within 24
              hours and your logo will go live on the agreed surfaces. We'll
              send a confirmation email shortly.
            </p>
            <Link
              to="/"
              className="btn-gold sponsorThanksCta"
              data-testid="sponsor-thanks-home"
            >
              Back to vmeetio <ArrowRight size={14} />
            </Link>
          </>
        ) : (
          <>
            <Loader2 size={48} className="sponsorThanksLoadingIcon" />
            <p className="overline sponsorThanksOverline">Confirming payment</p>
            <h1 className="font-display sponsorThanksTitleSmall">One second…</h1>
            <p className="sponsorThanksMuted">
              Stripe is confirming your payment. This usually takes a few
              seconds.
            </p>
          </>
        )}
      </div>
    </div>
  );
}